import { create } from 'zustand'
import type { User } from 'firebase/auth'

type UserStore = {
  user?: User
  setUser: (user: User) => void
  removeUser: () => void
}

export const useUserStore = create<UserStore>(set => ({
  user: undefined,
  setUser: (user: User) => set(() => ({ user: user })),
  removeUser: () => set(() => ({ user: undefined })),
}))

type StaffStore = {
  staff: User | null
  setStaff: (staff: User) => void
  removeStaff: () => void
}

export const useStaffStore = create<StaffStore>(set => ({
  staff: null,
  setStaff: (staff: User) => set(() => ({ staff: staff })),
  removeStaff: () => set(() => ({ staff: null })),
}))

type OwnerStore = {
  owner: User | null
  setOwner: (owner: User) => void
  removeOwner: () => void
}

export const useOwnerStore = create<OwnerStore>(set => ({
  owner: null,
  setOwner: (owner: User) => set(() => ({ owner: owner })),
  removeOwner: () => set(() => ({ owner: null })),
}))
